import React from 'react'
import Attachment from "../../../../../model2/attachment/attachment";
import {AttachmentSystemType} from "../../../../../model2/attachment/@types";

const debug = false
// const debug = "AttachmentButtonDownload"

type Props = {
    attachment   : Attachment
    className?   : string
}

export default function AttachmentButtonDownload(props: Props):any {

    if (!props.attachment) return false

    const onClickBtn = (e: any) => {
        e.stopPropagation()

        if (props.attachment?.systemType === AttachmentSystemType.CUSTOM){

            console.log(debug, "System type? ", AttachmentSystemType.CUSTOM)

            props.attachment.downloadByFileObject()
        }
        else{

            console.log(debug, "System type? ", AttachmentSystemType.DEFAULT)

            props.attachment.download()
        }
    }

    const classes = Classes("ui5-ico-round i5-download", props.className)

    return <div className = {classes}
                onClick   = {onClickBtn}></div>

    // return <a href      = {props.attachment.downloadUrl()}
    //           className = {classes}
    //           onClick   = {onClickBtn} />
}
